import {BigDecimal, MoneyResponseBody} from '@dms/api/shared';

export type CancelRentalOrderVehicleApiResponse = void;
export type CancelRentalOrderVehicleApiArg = {
  rentalOrderId: string;
  cancellationReasonId: string;
};
export type ChangeRentalOrderCustomerApiResponse = void;
export type ChangeRentalOrderCustomerApiArg = {
  rentalOrderId: string;
  changeRentalOrderCustomerRequestBody: ChangeRentalOrderCustomerRequestBody;
};
export type ChangeOrderRentVehicleApiResponse = void;
export type ChangeOrderRentVehicleApiArg = {
  rentalOrderId: string;

  changeOrderRentVehicleRequestBody: ChangeOrderRentVehicleRequestBody;
};
export type ChangeOrderReturnVehicleApiResponse = void;
export type ChangeOrderReturnVehicleApiArg = {
  rentalOrderId: string;

  changeOrderReturnVehicleRequestBody: ChangeOrderReturnVehicleRequestBody;
};
export type ChangeRentalOrderBranchApiResponse = /** status 204  */ void;
export type ChangeRentalOrderBranchApiArg = {
  rentalOrderId: string;
  changeRentalOrderBranchRequestBody: ChangeRentalOrderBranchRequestBody;
};
export type ChangeRentVehicleInspectionRequestBody = {
  inspections: string[];
};
export type ChangeReturnVehicleInspectionRequestBody = {
  inspections: string[];
};
export type ChangeRentVehicleInspectionApiResponse = /** status 204  */ void;
export type ChangeRentVehicleInspectionApiArg = {
  rentalOrderId: string;
  changeRentVehicleInspectionRequestBody: ChangeRentVehicleInspectionRequestBody;
};
export type ChangeReturnVehicleInspectionApiResponse = /** status 204  */ void;
export type ChangeReturnVehicleInspectionApiArg = {
  rentalOrderId: string;
  changeReturnVehicleInspectionRequestBody: ChangeReturnVehicleInspectionRequestBody;
};
export type ChangeRentalOrderBranchRequestBody = {
  branchId: string;
};
export type ChangeRentalOrderServiceOrderApiResponse = void;
export type ChangeRentalOrderServiceOrderApiArg = {
  rentalOrderId: string;
  changeRentalOrderServiceOrderRequestBody: ChangeRentalOrderServiceOrderRequestBody;
};
export type RemoveRentalOrderServiceOrderApiResponse = void;
export type RemoveRentalOrderServiceOrderApiArg = {
  rentalOrderId: string;
};
export type ChangeRentalOrderVehicleApiResponse = void;
export type ChangeRentalOrderVehicleApiArg = {
  rentalOrderId: string;

  changeRentalOrderVehicleRequestBody: ChangeRentalOrderVehicleRequestBody;
};
export type CreateRentalOrderApiResponse = UuidResponseBody;
export type CreateRentalOrderApiArg = {
  createRentalOrderRequestBody: CreateRentalOrderRequestBody;
};
export type CreateRentalOrderContractDocumentApiResponse = UuidResponseBody;
export type CreateRentalOrderContractDocumentApiArg = {
  rentalOrderId: string;
  templateId?: string | null;
};
export type CreateRentalOrderReturnDocumentApiResponse = UuidResponseBody;
export type CreateRentalOrderReturnDocumentApiArg = {
  rentalOrderId: string;
  templateId?: string | null;
};
export type GetRentalOrderApiResponse = RentalOrderResponseBody;
export type GetRentalOrderApiArg = {
  rentalOrderId: string;
};
export type RemoveRentalOrderApiResponse = void;
export type RemoveRentalOrderApiArg = {
  rentalOrderId: string;
};
export type RentRentalOrderVehicleApiResponse = void;
export type RentRentalOrderVehicleApiArg = {
  rentalOrderId: string;
};
export type ReserveRentalOrderVehicleApiResponse = void;
export type ReserveRentalOrderVehicleApiArg = {
  rentalOrderId: string;
};
export type ReturnRentalOrderVehicleApiResponse = void;
export type ReturnRentalOrderVehicleApiArg = {
  rentalOrderId: string;
};
export type CreateRentalSettingsApiResponse = UuidResponseBody;
export type CreateRentalSettingsApiArg = {
  createRentalSettingsRequestBody: CreateRentalSettingsRequestBody;
};
export type ListRentalSettingsApiResponse = RentalSettingsResponseBody[];
export type ListRentalSettingsApiArg = Record<string, never>;
export type GetRentalSettingsApiResponse = RentalSettingsResponseBody;
export type GetRentalSettingsApiArg = {
  rentalSettingsId: string;
};
export type RemoveRentalSettingsApiResponse = void;
export type RemoveRentalSettingsApiArg = {
  rentalSettingsId: string;
};
export type UpdateRentalSettingsApiResponse = void;
export type UpdateRentalSettingsApiArg = {
  rentalSettingsId: string;
  updateRentalSettingsRequestBody: UpdateRentalSettingsRequestBody;
};
export type AvailableVehicleListApiResponse = AvailableVehicleResponseBody[];
export type AvailableVehicleListApiArg = {
  from?: string;
  to?: string;
  term?: string | null;
  rentalOrderId?: string | null;
};

export type ChangeRentalOrderCustomerRequestBody = {
  customerId: string;
};
export type CoordinatesRequestBody = {
  latitude: string;
  longitude: string;
};
export type CommonAddressRequestBody = {
  street: string;
  descriptiveNumber?: string | null;
  orientationNumber?: string | null;
  city: string;
  zip: string;
  addressComplement?: string | null;
  country: string;
  prefix?: string | null;
  district?: string | null;
  state?: string | null;
  postal?: string | null;
  coordinates?: CoordinatesRequestBody | null;
  externalAddressId?: string | null;
};
export type PriceRequestBody = {
  withoutVat: BigDecimal;
  vat: BigDecimal;
  withVat: BigDecimal;
  vatRate: BigDecimal;
  vatType: string;
};
export type DiscountRequestBody = {
  discount: PriceRequestBody;
  percent: BigDecimal;
};
export type RentPriceRequestBody = {
  dailyRate: BigDecimal;
  paidDays: number;
  freeDailyKilometers: number;
  totalFreeKilometers: number;
  rentalPrice: PriceRequestBody;
  pricePerKilometer: PriceRequestBody;
  deliveryPrice: PriceRequestBody;
  otherPrice: PriceRequestBody;
  discount: DiscountRequestBody;
};
export type PhoneNumberRequestBody = {
  countryCode: string;
  number: string;
  prefix: string;
};
export type AuthorizedPersonRequestBody = {
  name: string;
  phoneNumber: PhoneNumberRequestBody | null;
  idCardNumber: string | null;
  drivingLicenceNumber: string | null;
};
export type ChangeOrderRentVehicleRequestBody = {
  rentType: string;
  fuelTank: BigDecimal | null;
  batteryCharge: BigDecimal | null;
  actualMileage: number;
  rentAddress: CommonAddressRequestBody;
  returnAddress: CommonAddressRequestBody | null;
  rentPrice: RentPriceRequestBody;
  customRentPrice: PriceRequestBody | null;
  authorizedPersons: AuthorizedPersonRequestBody[];
  equipment: string[];
};
export type ChargedAmountRequestBody = {
  price: PriceRequestBody;
  amount: BigDecimal;
};
export type ReturnPriceRequestBody = {
  dailyRate: string;
  paidDays: number;
  freeDailyKilometers: number;
  totalFreeKilometers: number;
  rentalPrice: PriceRequestBody;
  pricePerKilometer: PriceRequestBody;
  deliveryPrice: PriceRequestBody;
  otherPrice: PriceRequestBody;
  coPayment: PriceRequestBody;
  contractPenalty: PriceRequestBody;
  discount: DiscountRequestBody;
  chargedKilometer: ChargedAmountRequestBody;
  chargedFuel: ChargedAmountRequestBody;
};
export type RentalPeriodRequestBody = {
  from: string;
  to: string;
};
export type ChangeOrderReturnVehicleRequestBody = {
  rentType: string;
  fuelTank: BigDecimal | null;
  batteryCharge: BigDecimal | null;
  actualMileage: number;
  rentAddress: CommonAddressRequestBody;
  returnAddress: CommonAddressRequestBody | null;
  rentPrice: ReturnPriceRequestBody;
  customRentPrice: PriceRequestBody | null;
  rentalPeriod: RentalPeriodRequestBody;
  authorizedPersons: AuthorizedPersonRequestBody[];
  equipment: string[];
};
export type ChangeRentalOrderServiceOrderRequestBody = {
  serviceOrderId: string;
};
export type ChangeRentalOrderVehicleRequestBody = {
  rentalVehicleId: string;
  rentalPeriod: RentalPeriodRequestBody;
};
export type UuidResponseBody = {
  id: string;
};
export type CreateRentalOrderRequestBody = {
  rentalVehicleId: string | null;
  customerId: string | null;
  rentalPeriod: RentalPeriodRequestBody | null;
};
export type RentalPeriodResponseBody = {
  from: string;
  to: string;
};
export type CoordinatesResponseBody = {
  latitude: string;
  longitude: string;
};
export type CommonAddressResponseBody = {
  street: string;
  descriptiveNumber: string | null;
  orientationNumber: string | null;
  city: string;
  zip: string;
  addressComplement: string | null;
  country: string;
  prefix: string | null;
  district: string | null;
  state: string | null;
  postal: string | null;
  coordinates: CoordinatesResponseBody | null;
  externalAddressId: string | null;
};
export type RentingStateApiResponse = RentingStateResponseBody;
export type RentingStateApiArg = {
  rentalOrderId: string;
};
export type RentedOrderResponseBody = {
  rentalOrderId: string;
  number: string;
  rentalPeriod: RentalPeriodResponseBody;
};
export type RentingStateResponseBody = {
  isRentable: boolean;
  errorMessages: string[];
  rentedOrder: RentedOrderResponseBody | null;
};
export type PriceResponseBody = {
  withoutVat: string;
  vat: string;
  withVat: string;
  vatRate: string;
  vatType: string;
};
export type DiscountResponseBody = {
  discount: PriceResponseBody;
  percent: string;
};
export type SummaryPriceResponseBody = {
  withoutVat: string;
  vat: string;
  withVat: string;
};
export type RentPriceResponseBody = {
  dailyRate: string;
  paidDays: number;
  freeDailyKilometers: number;
  totalFreeKilometers: number;
  rentalPrice: PriceResponseBody;
  pricePerKilometer: PriceResponseBody;
  deliveryPrice: PriceResponseBody;
  otherPrice: PriceResponseBody;
  discount: DiscountResponseBody;
  summaryPrice: SummaryPriceResponseBody;
};
export type PhoneNumberResponseBody = {
  countryCode: string;
  number: string;
  prefix: string;
};
export type AuthorizedPersonResponseBody = {
  name: string;
  phoneNumber: PhoneNumberResponseBody;
  idCardNumber: string | null;
  drivingLicenceNumber: string | null;
};
export type RentVehicleResponseBody = {
  rentType: string;
  fuelTank: BigDecimal | null;
  batteryCharge: BigDecimal | null;
  actualMileage: number;
  rentAddress: CommonAddressResponseBody;
  returnAddress: CommonAddressResponseBody | null;
  rentPrice: RentPriceResponseBody;
  customRentPrice: PriceResponseBody | null;
  authorizedPersons: AuthorizedPersonResponseBody[];
  equipment: string[];
};
export type ChargedAmountResponseBody = {
  price: PriceResponseBody;
  amount: string;
};
export type ReturnPriceResponseBody = {
  dailyRate: string;
  paidDays: number;
  freeDailyKilometers: number;
  totalFreeKilometers: number;
  rentalPrice: PriceResponseBody;
  pricePerKilometer: PriceResponseBody;
  deliveryPrice: PriceResponseBody;
  otherPrice: PriceResponseBody;
  coPayment: PriceResponseBody;
  contractPenalty: PriceResponseBody;
  discount: DiscountResponseBody;
  chargedKilometer: ChargedAmountResponseBody;
  chargedFuel: ChargedAmountResponseBody;
  summaryPrice: SummaryPriceResponseBody;
};
export type ReturnVehicleResponseBody = {
  rentType: string;
  fuelTank: BigDecimal | null;
  batteryCharge: BigDecimal | null;
  actualMileage: number;
  rentAddress: CommonAddressResponseBody;
  returnAddress: CommonAddressResponseBody | null;
  rentPrice: ReturnPriceResponseBody;
  customRentPrice: PriceResponseBody | null;
  rentalPeriod: RentalPeriodResponseBody;
  authorizedPersons: AuthorizedPersonResponseBody[];
  equipment: string[];
};
export type RentalOrderResponseBody = {
  rentalOrderId: string;
  branchId: string;
  number: string;
  rentalVehicleId: string | null;
  customerId: string | null;
  serviceOrderId: string | null;
  plannedRentalPeriod: RentalPeriodResponseBody | null;
  state: 'draft' | 'reserved' | 'rented' | 'returned' | 'closed' | 'canceled';
  cancellationReasonId: string | null;
  rentVehicle: RentVehicleResponseBody | null;
  returnVehicle: ReturnVehicleResponseBody | null;
  rentVehicleInspections: string[];
  returnVehicleInspections: string[];
};
export type CreateRentalSettingsRequestBody = {
  branchId: string | null;
  orderSeriesId: string;
};
export type RentalSettingsResponseBody = {
  rentalSettingsId: string;
  branchId: string | null;
  orderSeriesId: string;
};
export type UpdateRentalSettingsRequestBody = {
  branchId: string | null;
  orderSeriesId: string;
};
export type AvailableVehicleResponseBody = {
  vehicleId: string;
  make: string;
  model: string;
  variant: string | null;
  vin: string | null;
  registrationPlate: string | null;
  rate: string | null;
  title: string;
};
export type RentalCalendarEventType = 'rental_order' | 'block';
export type RentalCalendarEventResponseBody = {
  id: string;
  type: RentalCalendarEventType;
  vehicleId: string;
  number: string | null;
  /** Vehicle block reason (`vehicleBlock` codelist); only a `block` event carries one */
  reasonId: string | null;
  /** Order state; a `block` event carries none */
  state: RentalOrderResponseBody['state'] | null;
  scheduledRent: string;
  scheduledReturn: string | null;
  vehicleRent: string | null;
  vehicleReturn: string | null;
  customerName: string | null;
  vin: string | null;
  rentalLength: number | null;
  dailyRate: MoneyResponseBody | null;
  expectedPrice: MoneyResponseBody | null;
  expectedPriceWithVat: MoneyResponseBody | null;
  salePrice: MoneyResponseBody | null;
  salePriceWithVat: MoneyResponseBody | null;
  rentMileage: number | null;
  returnMileage: number | null;
  address: string | null;
  returnAddress: string | null;
};
export type ListRentalCalendarEventsApiResponse = RentalCalendarEventResponseBody[];
export type ListRentalCalendarEventsApiArg = {
  from: string;
  to: string;
  vehicleId?: string[];
};
